import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Navigate } from "react-router";
import { Link } from "react-router-dom";

import { Alert } from "../../Component/Alert";
import { ServerErrorPage } from "../../Component/ServerErrorPage";

import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import SidebarObject from "../../Component/SidebarObject";

import StatBox from "./StatBox";
import "./style.css";

const drawerWidth = 240;

class SubjectStatsAtoms extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            error: "",
            updateComponent: 0,
            publicWarning: false,
            redirectToNewSlug: undefined
        };

        this.resetStats   = this.resetStats.bind(this);
        this.onSubmit     = this.onSubmit.bind(this);
        this.subject      = this.subject.bind(this);
        this.togglePublic = this.togglePublic.bind(this);
    }

    componentDidMount() {
        console.log("B");
        this.fetchSubject();
        this.fetchAtomScores();
    }

    public render() {
        console.log("A");
        if (this.state.redirectToNewSlug) {
            let newSubjectSlug = `${this.props.match.params.user}/${this.state.redirectToNewSlug}`;
            return <Navigate to={`/modquiz/subject/${newSubjectSlug}/settings`} />;
        }

        if (this.props.rootStore.subjectStore.state == "pending") {
            return <CircularProgress color="inherit" />;
        }

        if (this.props.rootStore.subjectStore.state == "error") {
            return <ServerErrorPage />;
        }

        let html: JSX.Element = <div></div>;

        const subject = this.subject();

        const isLoggedIn = this.props.rootStore.profileStore.isLoggedIn;

        if (!subject) return html;

        const quizObjects = Array.from(subject.objects, (x: any) => x[1]);
        const atomTracking = this.props.rootStore.subjectStore.atomTracking;
        console.log(quizObjects);

        return (
            <Grid container direction="row">
                <Grid item xs={"auto"} sm={3} md={2}>
                    <SidebarObject
                        subjectHashKey={subject.hash_key}
                        hasCreateAccess={isLoggedIn}
                        subject={subject}
                        subject_user={subject.user}
                        subject_slug={subject.slug}
                    />
                </Grid>
                <Grid item xs={12} sm={9} md={10}>
                    <Paper className="padding-3" square>
                        <br />
                        <h1>Stats</h1>
                        <br />
                        <br />
                        <div className="SubjectStats"></div>
                        <br />

                        <div className="title-bold">Today</div>
                        <div className="row">
                            <StatBox
                                colWidth={4}
                                title="Percent complete today"
                                data={this.props.rootStore.quizzerStore.quiz_user_subject_tracking.percent_complete_today()}
                                percent={true}
                            />
                            <StatBox
                                colWidth={4}
                                title="Questions left for today"
                                data={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .daily_questions_left
                                }
                                percent={false}
                            />
                        </div>
                        <div className="title-bold">Total</div>
                        <div className="row">
                            <StatBox
                                colWidth={4}
                                title="Total questions to answer today"
                                data={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .daily_questions_total
                                }
                                percent={false}
                            />
                            <StatBox
                                colWidth={4}
                                title="Total percent subject complete"
                                data={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .total_completion_percent
                                }
                                percent={true}
                            />
                            <StatBox
                                colWidth={4}
                                title="Total number of questions in subject"
                                data={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .questions_total
                                }
                                percent={false}
                            />
                        </div>
                        <Alert status="error" message={this.state.error} />
                        <br />
                        <h2>Atoms</h2>
                        <Link
                            to={`/subject/${this.props.match.params.user}/${this.props.match.params.subject}/stats`}
                        >
                            Objects
                        </Link>
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Quiz Object</th>
                                <th>Data Type</th>
                                <th>Score</th>
                                <th>Ask After</th>
                                <th>Last Asked</th>
                                <th>dataTypeLocator</th>
                            </tr>
                            </thead>
                            <tbody>
                                {atomTracking.map((atom: any) => {
                                    return (
                                        <tr>
                                            <td>{atom.quiz_object}</td>
                                            <td>{atom.dataType}</td>
                                            <td>{atom.score}</td>
                                            <td>{atom.ask_after}</td>
                                            <td>{atom.last_asked}</td>
                                            <td>{atom.dataTypeID}</td>
                                            <td>{atom.dataTypeLocator}</td>
                                            {/* <td>{atom.history}</td> */}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <button
                            onClick={this.resetStats}
                        >
                            Reset
                        </button>

                    </Paper>
                </Grid>
            </Grid>
        );
    }

    private resetStats() {
        this.props.rootStore.subjectStore.resetStats(
            this.props.match.params.user,
            this.props.match.params.subject
        );
    }

    private fetchSubject() {
        this.props.rootStore.subjectStore.fetchOne(
            this.props.match.params.user,
            this.props.match.params.subject
        );
    }

    private fetchAtomScores() {
        this.props.rootStore.subjectStore.fetchAtomScores(
            this.props.match.params.user,
            this.props.match.params.subject
        );
    }

    private subjectHashKey() {
        return `${this.props.match.params.user}/${this.props.match.params.subject}`;
    }

    private subject() {
        return this.props.rootStore.subjectStore.subjects.get(
            this.subjectHashKey()
        );
    }

    private togglePublic(ev: any) {
        const subject = this.subject();
        if (!subject.public) {
            subject.public = !subject.public;
            this.props.rootStore.subjectStore.subjects.set(
                this.subjectHashKey(),
                subject
            );
        } else {
            this.setState({
                publicWarning: "Sorry, you can't make a public subject private"
            });
        }
    }

    private onSubmit() {
        const component = this;
        const oldSlug = this.props.match.params.subject;
        this.props.rootStore.subjectStore.subjects
            .get(this.subjectHashKey())
            .save((err: any, newSlug: string) => {
                if (err) {
                    component.setState({
                        error: err.title
                    });
                }
                if (oldSlug !== newSlug) {
                    component.setState({
                        redirectToNewSlug: newSlug
                    });
                }
            });
    }
}

export default observer(SubjectStatsAtoms);
